import { CaseCreatePage } from "@/features/case/pages/CaseCreatePage";

export const CaseCreate = () => {
  return <CaseCreatePage />;
};
